import type { JSX } from "react";
import { sourceData } from "../constants/source.constants";
import { categoryIcons } from "../constants/sourceCategoryIcons";
import type { CategoryId } from "../types/source.types";

// Enhanced function that uses subcategory and category information
export function getSourceIconsByMetadata(
  category: CategoryId,
  subcategory: string,
): JSX.Element[] {
  const icons: JSX.Element[] = [];

  // Map of subcategory IDs to icon keys
  const subcategoryIconMap: Record<string, keyof typeof categoryIcons> = {
    // Print subcategories
    broadsheet: "broadsheet",
    tabloid: "tabloids",
    magazine: "magazines",
    provincial: "provincial",

    // Online subcategories
    "online-news": "social-media",
    blogs: "social-media",
    newsletters: "social-media",

    // TV subcategories
    tv: "tv-channels",
    "cable-tv": "tv-channels",

    // Radio subcategories
    radio: "am-radio",
    "am-radio": "am-radio",
    "fm-radio": "fm-radio",
  };

  // Try to get icon by subcategory first
  const iconKey = subcategoryIconMap[subcategory];
  if (iconKey && categoryIcons[iconKey]) {
    icons.push(categoryIcons[iconKey]);
  } else {
    // Fallback to category-based icon
    const fallbackIcons: Record<CategoryId, keyof typeof categoryIcons> = {
      print: "newspapers",
      online: "social-media",
      tv: "tv-channels",
      radio: "am-radio",
    };

    const fallbackKey = fallbackIcons[category];
    if (fallbackKey && categoryIcons[fallbackKey]) {
      icons.push(categoryIcons[fallbackKey]);
    }
  }

  return icons;
}

// Legacy function for backward compatibility
export function getSourceIcons(sourceName: string) {
  const icons: JSX.Element[] = [];

  for (const [categoryKey, categoryData] of Object.entries(sourceData)) {
    if (categoryData.subFields.includes(sourceName)) {
      const icon = categoryIcons[categoryKey as keyof typeof categoryIcons];
      if (icon) icons.push(icon);
    }
  }

  return icons;
}
